import {Component} from "@angular/core";
import {formatCurrency} from "@angular/common";

@Component({
  selector: 'app-detail-table',
  templateUrl: './restricted-mandate-listings.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class RestrictedMandateListingsComponent {
  tableColumns: string[];
  tableData: any[];
  emptyValuePlaceholder = '-';
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
    this.showTable = true;
  }

  showMaxBedrag(data) {
    if(data.maxAmount) {
      return formatCurrency(data.maxAmount, 'nl', '€');
    } else if (data.minAmount) {
      return formatCurrency(data.minAmount, 'nl', '€');
    }
    return this.emptyValuePlaceholder;
  }
}
